import { Api } from 'models/services/api';
import { DeleteFranchiseeQuery } from 'models/services/graphql';

import { FranchiseeData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteFranchisee($id: ID!) {
    ${DeleteFranchiseeQuery}
  }
`;

type ResponseData = {
  data: {
    deleteFranchisee: FranchiseeData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: FranchiseeData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteFranchisee;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };